<template>
    <div :class="classes">
        <div :class="[prefixCls + '-header']">
            <span v-for="day in headerDays" :key="day">
                {{day}}
            </span>
        </div>
        <div :class="getCellRowCls(row)" v-for="row in cells" :key="row.week" :data-week="row.week">
            <span
                :class="getCellCls(cell)"
                @click="handleClick(cell, $event)"
                v-for="(cell, j) in row.cells"
                :key="String(cell.date) + j">
                <em>{{cell.desc}}</em>
                <!-- <em>{{i* 7 + j}}</em> -->
            </span>
        </div>
    </div>
</template>
<script>
    import { clearHours, isInRange } from '../util'
    import { getWebLang} from '../../../../utils/lang'
    import Locale from '../../../../mixins/locale'
    import jsCalendar from 'js-calendar'
    import mixin from './mixin'
    import prefixCls from './prefixCls'

    export default {
        mixins: [Locale, mixin],
        inject: ['datePickerRoot'],
        props: {
            showWeekNumbers: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                prefixCls: prefixCls,
                lang:''
            }
        },
        computed: {
            classes() {
                return [
                    `${prefixCls}`,
                    {
                        [`${prefixCls}-show-week-numbers`]: this.showWeekNumbers
                    }
                ]
            },
            calendar() {
                const weekStartDay = this.weekStartDay == undefined ? Number(this.t('datepicker.weekStartDay')) : this.weekStartDay
                return new jsCalendar.Generator({
                    onlyDays: !this.showWeekNumbers,
                    weekStart: weekStartDay
                })
            },
            headerDays() {
                const weekStartDay = this.weekStartDay == undefined ? Number(this.t('datepicker.weekStartDay')) : this.weekStartDay
                const translatedDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].map(item => {
                    return this.t('datepicker.weeks.' + item)
                })
                const weekDays = translatedDays.splice(weekStartDay, 7 - weekStartDay).concat(translatedDays.splice(0, weekStartDay))
                return this.showWeekNumbers ? [''].concat(weekDays) : weekDays
            },
            cells() {
                const tableYear = this.tableDate.getFullYear()
                const tableMonth = this.tableDate.getMonth()
                const today = clearHours(new Date())
                const selectedDays = this.dates.filter(Boolean).map(clearHours)
                const [minDay, maxDay] = this.dates.map(clearHours)
                const rangeStart = this.rangeState.from && clearHours(this.rangeState.from)
                const rangeEnd = this.rangeState.to && clearHours(this.rangeState.to)

                const isRange = this.selectionMode === 'range'
                const disabledTestFn = typeof this.disabledDate === 'function' && this.disabledDate

                const tmp = this.calendar(tableYear, tableMonth, (cell) => {
                    if (cell.date instanceof Date) cell.date.setTime(cell.date.getTime() + cell.date.getTimezoneOffset() * 60000)

                    const time = cell.date && clearHours(cell.date)
                    const dateIsInCurrentMonth = cell.date && tableMonth === cell.date.getMonth()
                    return {
                        ...cell,
                        type: time === today ? 'today' : cell.type,
                        desc: (time === today && this.lang === 'zhs') ? '今' :cell.desc,
                        selected: dateIsInCurrentMonth && selectedDays.includes(time),
                        disabled: (cell.date && disabledTestFn) && disabledTestFn(new Date(time)),
                        range: dateIsInCurrentMonth && isRange && isInRange(time, rangeStart, rangeEnd),
                        start: dateIsInCurrentMonth && isRange && time === minDay,
                        end: dateIsInCurrentMonth && isRange && time === maxDay
                    }
                }).cells.slice(this.showWeekNumbers ? 8 : 0)
                let len = 7
                if (this.showWeekNumbers) len = 8
                const result = []
                for (let i = 0;i < 6;i ++) {
                    result.push({
                        week: tmp[i * len].week,
                        cells: tmp.slice(i * len, i * len + len)
                    })
                }
                return result
            }
        },
        methods: {
            getCellCls(cell) {
                return [
                    `${prefixCls}-cell`,
                    {
                        // [`${prefixCls}-cell-selected`]: cell.selected || cell.start || cell.end,
                        [`${prefixCls}-cell-disabled`]: cell.disabled,
                        [`${prefixCls}-cell-today`]: cell.type === 'today',
                        [`${prefixCls}-cell-prev-month`]: cell.type === 'prevMonth',
                        [`${prefixCls}-cell-next-month`]: cell.type === 'nextMonth',
                        [`${prefixCls}-cell-week-label`]: cell.type === 'weekLabel',
                        [`${prefixCls}-cell-range`]: cell.range && !cell.start && !cell.end,
                        [`${prefixCls}-focused`]: clearHours(cell.date) === clearHours(this.focusedDate)
                    }
                ]
            },
            getCellRowCls(row) {
                const start = row.cells[0].date ? row.cells[0].date :row.cells[1].date;
                const end = row.cells[row.cells.length - 1].date
                const date = clearHours(this.dates[0])
                return [
                    prefixCls + '-week',
                    {
                        [prefixCls + '-week-selected']: date >= start && date <= end,
                        [prefixCls + '-dbweek']: this.datePickerRoot && this.datePickerRoot.dbweek
                    }
                ]
            }
        },
        created(){
            getWebLang().then(res => {
                this.lang=res
            })
        }
    }
</script>
